<section
  class="details-page__location"
  [class.fromBottomSheet]="fromBottomSheet()"
>
    <h3 class="ci-heading-h3-s-bold location__title">
      {{ 'Dirección' | translate }}
    </h3>
    <p 
      class="location__text"
      (click)="handleClick()" 
    >
      {{ location()?.address }}
    </p>
</section>